import { fetcher } from "@/helpers/fetcher";
import { CodeValues } from "@/types/common";
import { DepartmentRoleType, DepartmentTreeNode } from "@/types/department";
import { useQuery } from "@tanstack/react-query";

export const queryUser = () => ({
  queryKey: ["current-user"],
  queryFn: async ({ signal }: { signal: AbortSignal }) => fetcher({ url: "/common/users/me", signal }),
});

export const queryCodeValues = () => ({
  queryKey: ["code-values"],
  queryFn: async ({ signal }: { signal: AbortSignal }): Promise<CodeValues> =>
    fetcher({ url: "/common/codes", signal }),
});

export const useCodeValues = () => {
  return useQuery<CodeValues>({ ...queryCodeValues() });
};

export const useDepartmentSearch = (searchTerm?: string, roleType?: DepartmentRoleType) => {
  return useQuery<DepartmentTreeNode[]>({
    queryKey: ["department-search", searchTerm, roleType],
    queryFn: async ({ signal }): Promise<DepartmentTreeNode[]> =>
      fetcher({
        url: "/common/departments",
        signal,
        params: { search: searchTerm ?? "", roleType },
      }),
  });
};

export const useDepartmentSearchIds = (ids: number[]) => {
  return useQuery<DepartmentTreeNode[]>({
    queryKey: ["department-search-ids", ids],
    queryFn: async ({ signal }): Promise<DepartmentTreeNode[]> =>
      fetcher({
        url: "/common/departments",
        signal,
        params: { ids: ids ?? [] },
      }),
  });
};
